"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInRange = void 0;
function isInRange(range, cashflowMonth) {
    if (range === '*') {
        return true;
    }
    if (typeof range === 'string') {
        return cashflowMonth === range;
    }
    if (range.eq && cashflowMonth !== range.eq) {
        return false;
    }
    if (range.gt && cashflowMonth <= range.gt) {
        return false;
    }
    if (range.gte && cashflowMonth < range.gte) {
        return false;
    }
    if (range.lt && cashflowMonth >= range.lt) {
        return false;
    }
    if (range.lte && cashflowMonth > range.lte) {
        return false;
    }
    return true;
}
exports.isInRange = isInRange;
